import { render, staticRenderFns } from "./TextMessages.vue?vue&type=template&id=9a45656e"
import script from "./TextMessages.vue?vue&type=script&lang=js"
export * from "./TextMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a45656e')) {
      api.createRecord('9a45656e', component.options)
    } else {
      api.reload('9a45656e', component.options)
    }
    module.hot.accept("./TextMessages.vue?vue&type=template&id=9a45656e", function () {
      api.rerender('9a45656e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextMessages.vue"
export default component.exports